import React from 'react';

export const CookieSettingsTrigger: React.FC = () => {
  const handleOpen = () => {
    window.dispatchEvent(new CustomEvent('open_cookie_settings'));
  };

  return (
    <button
      id="cookie-settings-trigger"
      type="button"
      onClick={handleOpen}
      className="fixed bottom-4 left-4 z-40 bg-[#0F1E32]/90 hover:bg-[#0F1E32] text-white p-2.5 rounded-full shadow-lg border border-slate-700/80 transition-all hover:scale-105 active:scale-95 flex items-center gap-2 group cursor-pointer focus:outline-none"
      title="Настройки за бисквитки & Поверителност (GDPR)"
      aria-label="Настройки за бисквитки"
    >
      <span className="text-base select-none leading-none">🍪</span>
      <span className="max-w-0 overflow-hidden whitespace-nowrap group-hover:max-w-xs transition-all duration-300 ease-in-out text-[11px] font-bold text-[#C5A46E] pr-1">
        Бисквитки
      </span>
    </button>
  );
};
